import { useState, useEffect } from 'react'
import blogService from '../../services/blogs'
import Blog from './Blog'
import styles from './Blogs.module.css'
import BlogForm from './BlogForm'
import Card from '../Card'
import Togglable from '../Togglable'

const Blogs = ({ user, setNotification }) => {
  const [blogs, setBlogs] = useState(null)
  const [showAll, setShowAll] = useState(true)

  useEffect(() => {
    blogService.getAll().then(data => {
      setBlogs(
        data.sort((a, b) => {
          return b.likes - a.likes
        })
      )
    })
  }, [])

  const blogsToShow = showAll
    ? blogs
    : blogs?.filter(blog => blog.user.id === user.id)

  // Service Calls

  const addBlog = blogObject => {
    blogService
      .create(blogObject)
      .then(data => {
        data.user = user

        setBlogs(blogs.concat(data)) // this doesn't show user

        setNotification({
          message: `Your new blog ${blogObject.title} by ${blogObject.author}  was successfully added!`,
          type: 'success',
        })
      })
      .catch(error => {
        setNotification({
          message: error.response.data.error,
          type: 'error',
        })
      })
  }

  const removeBlog = id => {
    const newBlogs = blogs.filter(blog => blog.id !== id)
    blogService
      .remove(id)
      .then(message => {
        setNotification({
          message: message
            ? message.response.data
            : 'Success: Blog was successfully deleted',
          type: 'success',
        })
        setBlogs(
          newBlogs.sort((a, b) => {
            return a.likes - b.likes
          })
        )
      })
      .catch(error => {
        setNotification({
          message: error.response.data.error,
          type: 'error',
        })
        setBlogs(newBlogs)
      })
  }

  const addLike = blogObject => {
    blogService
      .update(blogObject.id, blogObject)
      .then(data => {
        data.user = blogObject.user
        setBlogs(
          blogs.map(blog =>
            blog.id !== blogObject.id ? blog : data
          )
        ) //TODO: Fails when updating unexisting note
      })
      .catch(error => {
        console.log(error)
        setBlogs(
          blogs.filter(blog => blog.id !== blogObject.id)
        )
      })
  }

  const userLoggedIn = () => (
    <>
      <div style={{ margin: '2rem 1rem' }}>
        <button
          className="btn-accent-dark"
          onClick={() => setShowAll(!showAll)}
        >
          {showAll ? '⭐ show only yours' : 'show all'}
        </button>
      </div>
      <div className={[styles['blogs-layout']].join(' ')}>
        <BlogForm addBlog={addBlog} />

        {blogsToShow.map(blog => (
          <Card key={blog.id}>
            <Blog
              blog={blog}
              removeBlog={removeBlog}
              addLike={addLike}
              user={user}
            />
          </Card>
        ))}
      </div>
    </>
  )

  if (!blogs || blogs.length === 0) {
    return (
      <div className={[styles['blogs-layout']].join(' ')}>
        <BlogForm addBlog={addBlog} />
      </div>
    )
  }
  return (
    <>
      <p>
        No blogs to show. Create a new blog to get started!
      </p>
      {user ? (
        userLoggedIn()
      ) : (
        <p className="darker italic">
          Log in to see blogs{' '}
        </p>
      )}
    </>
  )
}
export default Blogs
